import { BackgroundIcon1 } from "../../assets/svg";
import Image_3 from "../../assets/3.jpeg";
import Image_17 from "../../assets/17.jpeg";
import Image_15 from "../../assets/15.jpeg";

const services = [
  {
    image: Image_3,
    title: "Trocken und Innenausbau",
    details:
      "Fachgerechte Trocken- und Innenausbauarbeiten für jedes Projekt. Wir schaffen funktionale und ästhetische Räume nach Ihren Wünschen.",
  },
  {
    image: Image_17,
    title: "Hausmeister arbeiten",
    details:
      "Umfassende Hausmeisterdienste für die Instandhaltung Ihrer Immobilie. Von kleinen Reparaturen bis zur Pflege der Außenanlagen, wir kümmern uns um alles.",
  },
  {
    image: Image_15,
    title: "Silikone arbeiten und entrümpeln von Wohnung und Keller",
    details:
      "Professionelle Silikonarbeiten und gründliche Entrümpelung für Wohnungen und Keller. Wir sorgen für dichte Fugen und klare Räume.",
  },
];

const Services = () => {
  return (
    <div className="relative ">
      <BackgroundIcon1 position="top-[50%] right-[5%]" />
      <BackgroundIcon1 position="top-[10%] left-[5%]" />
      <div className="flex flex-col justify-between w-full items-center mt-12 px-4 md:px-20">
        <h1 className="text-[30px] md:text-[60px] text-center">
          Unsere Dienstleistungen
        </h1>
        <div className="grid sm:grid-cols-3 gap-12 mt-12 px-4 md:px-0 w-full">
          {services.map((service) => (
            <div className="flex flex-col">
              <img
                src={service.image}
                className="z-10 object-cover h-[350px] w-[350px] rounded-md shadow-none transition-shadow duration-300 cursor-pointer hover:shadow-lg hover:shadow-gray-400"
                alt="19"
              />
              <p className="mt-2 font-semibold">{service.title}</p>
              <span>{service.details}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
